import {
  ACCEPT_INVITATION_FORM_EMAIL,
  ACCEPT_INVITATION_FORM_NAME,
} from '../../constants/ui.labels'
import Box from '@talkdesk/cobalt-react-box'
import InputGroup, { Item } from '@talkdesk/cobalt-react-input-group'
import Input from '@talkdesk/cobalt-react-input'
import Label from '@talkdesk/cobalt-react-label'

const AcceptInvitationForm = ({ name, email }) => (
  <Box>
    <Box paddingY='2'>
      <Label disabled>{ACCEPT_INVITATION_FORM_NAME}</Label>
    </Box>
    <InputGroup disabled>
      <Item>
        <Input value={name} type='text' variation='unstyled' disabled />
      </Item>
    </InputGroup>
    <Box paddingY='2'>
      <Label disabled>{ACCEPT_INVITATION_FORM_EMAIL}</Label>
    </Box>
    <InputGroup disabled>
      <Item>
        <Input value={email} type='text' variation='unstyled' disabled />
      </Item>
    </InputGroup>
  </Box>
)

export default AcceptInvitationForm
